/** Detección pura de invite-extensión (sin deps de RN / Edge). */

/** ¿El correo ya pertenece a un empleado activo del equipo (lista local)? */
export function isActiveEmployeeEmail(
  email: string,
  employees: Array<{ email?: string; isActive?: boolean }>
): boolean {
  const normalized = email.trim().toLowerCase();
  if (!normalized) return false;
  return employees.some(
    (e) =>
      e.isActive !== false &&
      typeof e.email === 'string' &&
      e.email.trim().toLowerCase() === normalized
  );
}
